module.exports = __webpack_public_path__ + "static/img/human-5.4ca294df.png";